'use strict';

import 'material-icons/iconfont/material-icons.css';
import 'material-symbols';
import AWN from "awesome-notifications";

if (typeof window !== 'undefined') {
    window.AWN = AWN;
}

/* Load JavaScript Files  */
require('./init.js');
require('./contents/test.js');
require('./contents/projects.js');
require('./contents/methodenfinder.js');
//require('./slick.min');

/* Load SASS Files */
require('./../sass/index.sass');

/* Load CSS Files */
require('./../css/index.css');
require('./../css/awn.css');

/* Load Inno Hub CSS Files */
require('./../css/inno-hub.css');
require('./../css/inno-hub-clean.css');
//require('./../css/inno-hub-comic.css');

const khRuntime = window.khThemeRuntime || {};
const khRestBaseUrl = String(khRuntime.restBaseUrl || '/wp-json/knowhub/v1').replace(/\/+$/, '');
const khUserAccessToken = String(khRuntime.userAccessToken || '');
const khLoadingImageUrl = String(khRuntime.loadingImageUrl || '');
const khMarkContentLabels = khRuntime.markContent || {};
const khMessages = khRuntime.messages || {};

const khMessage = (key, fallback) => khMessages[key] || fallback;

const khRestUrl = (path) => khRestBaseUrl + '/' + String(path || '').replace(/^\/+/, '');

const khRefreshSessionData = (delay = 0, success) => {
    window.setTimeout(() => {
        khRestAjax({
            method: 'POST',
            path: 'user/profile/refresh',
            success,
        });
    }, delay);
};

const khReloadWithRefreshData = (delay = 0) => {
    khRefreshSessionData(delay, () => {
        window.location.reload();
    });
};

const khTrackContentAnalytics = (contentId, contentTypeId, data = {}, callbacks = {}) => {
    const normalizedContentId = parseInt(contentId, 10);
    const normalizedContentTypeId = parseInt(contentTypeId, 10);

    if (!Number.isFinite(normalizedContentId) || normalizedContentId <= 0 || !Number.isFinite(normalizedContentTypeId) || normalizedContentTypeId <= 0) {
        return null;
    }

    return khRestAjax({
        method: 'POST',
        path: 'user/analytics/content/' + encodeURIComponent(normalizedContentId) + '/' + encodeURIComponent(normalizedContentTypeId),
        data,
        success: callbacks.success,
        error: callbacks.error,
        complete: callbacks.complete,
    });
};

const khExtractDownloadFilename = ($link, href, response) => {
    const contentDisposition = response.headers.get('Content-Disposition') || response.headers.get('content-disposition') || '';
    const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        try {
            return decodeURIComponent(utf8Match[1]);
        } catch (error) {
            return utf8Match[1];
        }
    }

    const plainMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i) || contentDisposition.match(/filename\s*=\s*([^;]+)/i);
    if (plainMatch && plainMatch[1]) {
        return plainMatch[1].trim();
    }

    const fileNameFromData = $link.data('file-name');
    if (typeof fileNameFromData === 'string' && fileNameFromData !== '') {
        const segments = fileNameFromData.split('/');
        return segments[segments.length - 1];
    }

    try {
        const url = new URL(href, window.location.origin);
        const fileName = url.searchParams.get('file_name');
        if (fileName) {
            const segments = fileName.split('/');
            return decodeURIComponent(segments[segments.length - 1]);
        }
    } catch (error) {
    }

    return 'attachment-download';
};

const khTriggerBlobDownload = (blob, filename) => {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    window.setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    }, 0);
};

const khDownloadAttachment = async ($link) => {
    const href = $link.attr('href') || '';
    if (!href) {
        return;
    }

    const headers = {};
    if (khUserAccessToken) {
        headers.Authorization = 'Bearer ' + khUserAccessToken;
    }

    const response = await window.fetch(href, {
        method: 'GET',
        credentials: 'same-origin',
        headers,
        cache: 'no-store',
    });

    if (!response.ok) {
        return;
    }

    const blob = await response.blob();
    const filename = khExtractDownloadFilename($link, href, response);
    khTriggerBlobDownload(blob, filename);
};

const khCanTrackWithConsent = () => {
    if (typeof cookieConsentData === 'undefined' || cookieConsentData === null) {
        return true;
    }

    if (typeof cookieConsentData.parsed === 'undefined' || cookieConsentData.parsed === null) {
        return true;
    }

    return cookieConsentData.parsed.preferences === true;
};

const khRestAjax = ({method = 'POST', path, data = {}, success, error, complete}) => {
    const payload = Object.assign({}, data);
    if (khUserAccessToken && !payload.user_access_token) {
        payload.user_access_token = khUserAccessToken;
    }

    return jQuery.ajax({
        type: method,
        url: khRestUrl(path),
        data: JSON.stringify(payload),
        contentType: 'application/json; charset=UTF-8',
        dataType: 'json',
        headers: khUserAccessToken ? {
            Authorization: 'Bearer ' + khUserAccessToken,
        } : {},
        success,
        error,
        complete,
    });
};

const getApiPayload = (data) => {
    if (data && typeof data === 'object' && typeof data.data !== 'undefined') {
        return data.data;
    }

    return data;
};

const isApiSuccess = (data) => {
    const payload = getApiPayload(data);

    if (payload && typeof payload === 'object') {
        if (typeof payload.status !== 'undefined') {
            const status = String(payload.status).toLowerCase();
            return status === 'true' || status === 'success' || status === 'ok';
        }

        if (typeof payload.success !== 'undefined') {
            return payload.success === true || payload.success === 'true';
        }
    }

    return data && data.success === true && payload !== false;
};

const getApiMessage = (data, fallback) => {
    const payload = getApiPayload(data);

    if (payload && typeof payload === 'object' && typeof payload.message === 'string' && payload.message.trim()) {
        return payload.message;
    }

    return fallback;
};

const khProfileAjaxPaths = {
    personal: 'theme/profile/personal',
    work: 'theme/profile/work',
    audience: 'theme/profile/audience',
    password: 'theme/profile/password',
};

const khProfileFormData = (form) => {
    const data = {};
    jQuery(form).serializeArray().forEach((field) => {
        if (Object.prototype.hasOwnProperty.call(data, field.name)) {
            if (!Array.isArray(data[field.name])) {
                data[field.name] = [data[field.name]];
            }
            data[field.name].push(field.value);
            return;
        }

        data[field.name] = field.value;
    });
    return data;
};

const khProfileViewUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('edit');
    return url.toString();
};

const khSetProfileButtonLoading = (button, isLoading) => {
    if (!button.length) {
        return;
    }

    if (isLoading) {
        if (typeof button.data('profile-original-html') === 'undefined') {
            button.data('profile-original-html', button.html());
        }

        const buttonWidth = button.outerWidth();
        const buttonHeight = button.outerHeight();

        let spinner = button.siblings('.profile-save-spinner').first();
        if (!spinner.length) {
            spinner = jQuery('<span>', {
                class: 'profile-save-spinner',
                role: 'status',
                'aria-live': 'polite',
            });
            button.after(spinner);
        }
        spinner.css({
            display: 'flex',
            height: buttonHeight,
            width: buttonWidth,
        });
        button.prop('disabled', true).hide();
        spinner.empty();
        if (khLoadingImageUrl) {
            spinner.append(jQuery('<img>', {
                alt: '',
                class: 'profile-save-loader',
                src: khLoadingImageUrl,
                width: 28,
                height: 28,
            }));
        } else {
            spinner.text(khMessage('profileSaving', 'Saving your data...'));
        }

        return;
    }

    const originalHtml = button.data('profile-original-html');
    if (typeof originalHtml !== 'undefined') {
        button.html(originalHtml);
    }

    button.prop('disabled', false).show();
    button.siblings('.profile-save-spinner').first().removeAttr('style').hide().empty();
};

jQuery(document).on('submit', 'form[data-profile-ajax]', function (event) {
    event.preventDefault();

    const form = jQuery(this);
    const action = String(form.data('profile-ajax') || '');
    const path = khProfileAjaxPaths[action];
    const submitButton = form.find('button[type="submit"], button:not([type])').last();
    if (!path || submitButton.prop('disabled')) {
        return;
    }

    const notifier = new AWN({
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('success', 'Success'),
            warning: khMessage('attention', 'Attention'),
            alert: khMessage('error', 'Error'),
        }
    });

    khSetProfileButtonLoading(submitButton, true);
    notifier.info(khMessage('profileSaving', 'Saving your data...'), {
        durations: {
            global: 3000
        }
    });

    khRestAjax({
        method: 'POST',
        path,
        data: khProfileFormData(form),
        success: function (data) {
            const message = getApiMessage(data, khMessage('profileSaveSuccess', 'Your update was successful.'));
            notifier.success(message, {
                durations: {
                    global: 5000
                }
            });

            const payload = getApiPayload(data);
            const redirectUrl = payload && payload.redirect ? payload.redirect : khProfileViewUrl();
            if (payload && payload.redirect) {
                window.setTimeout(() => {
                    window.location.href = redirectUrl;
                }, 3000);
                return;
            }

            window.setTimeout(() => {
                window.location.href = redirectUrl;
            }, 1500);
        },
        error: function (xhr) {
            const message = getApiMessage(xhr.responseJSON, khMessage('profileSaveError', 'Something went wrong while updating your data. Please try again.'));
            notifier.alert(message, {
                durations: {
                    global: 5000
                }
            });
        },
        complete: function () {
            khSetProfileButtonLoading(submitButton, false);
        }
    });
});

const channelWaitlistMessage = khMessage('channelWaitlist', 'You are on the waiting list. An admin must approve your request.');

const isChannelWaitlistResponse = (data) => {
    const payload = getApiPayload(data);

    if (!payload || typeof payload !== 'object') {
        return false;
    }

    const waitlistKeys = [
        'waitlist',
        'waiting_list',
        'on_waiting_list',
        'is_waiting_list',
        'requires_approval',
        'approval_required',
        'admin_approval_required',
    ];

    for (const key of waitlistKeys) {
        if (payload[key] === true || payload[key] === 1 || payload[key] === '1' || payload[key] === 'true') {
            return true;
        }
    }

    const status = String(
        payload.status ||
        payload.subscription_status ||
        payload.membership_status ||
        payload.join_status ||
        ''
    ).toLowerCase();

    if (/(waitlist|waiting|pending|approval|request)/.test(status)) {
        return true;
    }

    const message = String(payload.message || '').toLowerCase();
    return /(warteliste|waiting list|waitlist|pending|approval|anfrage.*bestät|admin.*bestät)/.test(message);
};

const getChannelSubscribeSuccessMessage = (data) => {
    if (isChannelWaitlistResponse(data)) {
        return channelWaitlistMessage;
    }

    return getApiMessage(data, khMessage('channelSubscribeSuccess', 'Channel subscribed successfully.'));
};

jQuery(document).on("click", "button.mark-content-for-user", function () {
    let content_id = jQuery(this).data('content-id');
    let globalOptions = {
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('successful', 'Successful'),
            warning: khMessage('attention', 'Attention')
        }
    };
    let notifier = new AWN(globalOptions);
    notifier.success(khMessage('contentMarking', 'Content is being marked...'), {

        durations: {
            global: 5000
        }
    });
    khRestAjax({
        method: 'POST',
        path: 'user/marks/' + encodeURIComponent(content_id),
        success: function (data) {
            jQuery('#mark-toggle-span-' + content_id + ' > span').empty().append(
                khMarkContentLabels.marked || 'You have marked this content'
            );

            jQuery('#mark-toggle-' + content_id).addClass('marked');
            // alter button
            jQuery('#btn-mark-' + content_id).removeClass('t-mark-content');
            jQuery('#btn-mark-' + content_id).removeClass('mark-content-for-user');
            jQuery('#btn-mark-' + content_id).addClass('t-marked-content');
            jQuery('#btn-mark-' + content_id).addClass('mark-remove-content-for-user');
        },
        error: function (errorThrown) {
        }
    });
});

jQuery(document).on("click", "button.mark-remove-content-for-user", function () {
    let content_id = jQuery(this).data('content-id');
    let globalOptions = {
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('success', 'Success'),
            warning: khMessage('attention', 'Attention')
        }
    };
    let notifier = new AWN(globalOptions);

    notifier.success(khMessage('contentRemovingFromWatchlist', 'Content is being removed from the watchlist.'), {

        durations: {
            global: 5000
        }
    });
    khRestAjax({
        method: 'DELETE',
        path: 'user/marks/' + encodeURIComponent(content_id),
        success: function (data) {


            jQuery('#dir-' + content_id).fadeOut();
            jQuery('#mark-toggle-span-' + content_id + ' > span').empty().append(
                khMarkContentLabels.unmarked || 'Mark this content'
            );
            jQuery('#mark-toggle-' + content_id).removeClass('marked');
            // alter button
            jQuery('#btn-mark-' + content_id).removeClass('t-marked-content');
            jQuery('#btn-mark-' + content_id).removeClass('mark-remove-content-for-user');
            jQuery('#btn-mark-' + content_id).addClass('t-mark-content');
            jQuery('#btn-mark-' + content_id).addClass('mark-content-for-user');

        },
        error: function (errorThrown) {
        }
    });
});

jQuery(document).on("click", "div.accordion-item", function () {
    const $item = jQuery(this);
    const contentType = String($item.data('content-type-id') || '').toLowerCase();
    const isTestContent = $item.hasClass('content-type-test') || $item.hasClass('content-type-test-attachment') || contentType === 'test';
    const ensureAccordionCheckmark = ($targetItem) => {
        const $summaryTop = $targetItem.find('summary .summary-top').first();
        if (!$summaryTop.length || $summaryTop.find('.summary-success').length) {
            return;
        }

        const $checkIcon = jQuery(
            '<div class="summary-success"><span class="t-nav-list-element-icon material-symbols-outlined">check</span></div>'
        );
        const $summaryTitle = $summaryTop.find('.summary-title').first();

        if ($summaryTitle.length) {
            $summaryTitle.before($checkIcon);
            return;
        }

        $summaryTop.prepend($checkIcon);
    };

    if (isTestContent) {
        return;
    }

    if (khCanTrackWithConsent()) {
        khTrackContentAnalytics($item.data('content-id'), $item.data('content-type-id'), {
            progress: 100,
        }, {
            success: function (data) {
                ensureAccordionCheckmark($item);
            },
            error: function (errorThrown) {

            }
        });
    }
});

jQuery(document).on('click', '.t-content-attachment-download-link', function (event) {
    event.preventDefault();
    event.stopPropagation();

    const $link = jQuery(this);

    if (khCanTrackWithConsent()) {
        khTrackContentAnalytics($link.data('content-id'), $link.data('content-type-id'), {
            download_triggered: true,
        });
    }

    khDownloadAttachment($link).catch(() => {});
});


jQuery(document).on("click", "button.t-event-register", function (e) {
    e.preventDefault();
    let event_id = jQuery(this).data('event-id');
    // Formvalidierung - alle required Felder im nächsten Form-Element finden
    let form = jQuery('#event-form-' + event_id);
    let requiredFields = form.find('[required]');
    let isValid = true;
    let emptyFields = [];

    // Überprüfe jedes required Feld, Checkboxen werden speziell behandelt
    requiredFields.each(function () {
        let field = jQuery(this);
        let type = field.attr('type');

        if (type === 'checkbox') {
            if (!field.is(':checked')) {
                isValid = false;
                field.addClass('is-invalid');
            } else {
                field.removeClass('is-invalid');
            }
        } else {
            let value = field.val().trim();
            if (value === '' || value === null) {
                isValid = false;
                field.addClass('is-invalid');
            } else {
                field.removeClass('is-invalid');
            }
        }
    });

    // Wenn nicht alle Felder ausgefüllt sind, zeige Errormeldung
    if (!isValid) {
        let globalOptions = {
            labels: {
                info: khMessage('info', 'Info'),
                success: khMessage('success', 'Success'),
                warning: khMessage('attention', 'Attention')
            }
        };
        let notifier = new AWN(globalOptions);
        notifier.alert(
            khMessage('eventRequiredFields', 'Please fill in all required fields: %s').replace('%s', emptyFields.join(', ')),
            {

            durations: {
                global: 3000
            }
            }
        );
        return;
    } else {

        let required_data = form.serializeArray();

        //let event_id = jQuery(this).data('event-id');
        let button = jQuery(this);
        let globalOptions = {
            labels: {
                info: khMessage('info', 'Info'),
                success: khMessage('success', 'Success'),
                warning: khMessage('attention', 'Attention')
            }
        };
        let notifier = new AWN(globalOptions);
        notifier.tip(khMessage('eventRegistering', 'You are being registered...'), {

            durations: {
                global: 5000
            }
        });
        khRestAjax({
            method: 'POST',
            path: 'event/' + encodeURIComponent(jQuery(this).data('event-id')) + '/accept',
            data: {
                user_details: JSON.stringify(required_data),
            },
            success: function (data) {
                notifier.success(khMessage('eventRegisterSuccess', 'You have successfully registered for the event.'), {

                    durations: {
                        global: 5000
                    }
                });
                jQuery('#t-event-status-icon').replaceWith(
                    '<div id="t-event-status-icon"><div class="summary-success"><span class="t-nav-list-element-icon material-symbols-outlined">how_to_reg</span></div></div>'
                );
                jQuery('#t-event-user-status-message').css('display', 'flex');
                button.removeClass('t-event-register btn-primary')
                    .addClass('t-event-unregister btn-secondary')
                    .attr('name', 't-event-unregister')
                    .text(khMessage('eventUnregisterButton', 'Unregister from event'));
                khReloadWithRefreshData();
            },
            error: function (errorThrown) {

            }
        });
    }
});

jQuery(document).on("click", "button.t-event-unregister", function (e) {
    let event_id = jQuery(this).data('event-id');
    let button = jQuery(this);
    let globalOptions = {
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('success', 'Success'),
            warning: khMessage('attention', 'Attention')
        }
    };
    let notifier = new AWN(globalOptions);
    notifier.tip(khMessage('eventUnregistering', 'You are being unregistered...'), {
        title: khMessage('eventUnregisteringTitle', 'Unsubscribing'),

        durations: {
            global: 5000
        }
    });
    khRestAjax({
        method: 'POST',
        path: 'event/' + encodeURIComponent(event_id) + '/decline',
        success: function (data) {
            notifier.success(khMessage('eventUnregisterSuccess', 'You have successfully unregistered from the event.'), {

                durations: {
                    global: 5000
                }
            });

            jQuery('#t-event-status-icon').replaceWith(
                '<div id="t-event-status-icon"><div class="summary-icon"><span class="t-nav-list-element-icon material-symbols-outlined">event</span></div></div>'
            );
            jQuery('#t-event-user-status-message').css('display', 'none');
            button.removeClass('t-event-unregister btn-secondary')
                .addClass('t-event-register btn-primary')
                .attr('name', 't-event-register')
                .text(khMessage('eventRegisterButton', 'Register for event'));
            khReloadWithRefreshData();
        },
        error: function (errorThrown) {

        }
    });
});

jQuery(document).ready(function ($) {
    var btn = $('#scrollToTopBtn');

    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            btn.fadeIn();
        } else {
            btn.fadeOut();
        }
    });

    btn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, '300');
    });
});

jQuery(document).on('click', 'summary', function () {
    var accordionItem = jQuery(this).closest('.accordion-item');

    setTimeout(function () {
        if (accordionItem.find('details').prop('open')) {
            var offsetTop = accordionItem.offset().top;
            var scrollTo = offsetTop - 100; // ggf. Offset anpassen (z. B. wegen Sticky Header)

            window.scrollTo({
                top: scrollTo,
                behavior: 'smooth'
            });
        }
    }, 200);
});

let channelSubscribeModal = null;
let channelSubscribeModalCheckbox = null;
let channelSubscribeModalError = null;
let channelSubscribeModalConfirm = null;
let pendingSubscribeButton = null;
let pendingSubscribeTeamId = null;

function getChannelSubscribeNotifier() {
    return new AWN({
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('success', 'Success'),
            warning: khMessage('attention', 'Attention'),
            alert: khMessage('error', 'Error')
        }
    });
}

function buildChannelSubscribeModal() {
    if (channelSubscribeModal) {
        return;
    }

    const modalHtml = `
        <div id="channel-subscribe-modal" class="channel-subscribe-overlay" style="display:none;">
            <div class="channel-subscribe-dialog" role="dialog" aria-modal="true" aria-labelledby="channel-subscribe-title">
                <div class="channel-subscribe-header">
                    <h5 id="channel-subscribe-title" class="channel-subscribe-title">${khMessage('channelSubscribeTitle', 'Subscribe to channel')}</h5>
                    <button type="button" class="channel-subscribe-close" aria-label="${khMessage('close', 'Close')}"><span class="material-symbols-outlined">close</span></button>
                </div>
                <div class="channel-subscribe-body">
                    <p class="channel-subscribe-text">${khMessage('channelSubscribeIntro', "Please confirm before subscribing that your user information may be transferred to the channel provider and that you accept the provider's privacy policy.")}</p>
                    <div class="channel-user-data-consent-wrap">
                        <input
                            type="checkbox"
                            name="channel_subscribe_modal_user_data_consent"
                            id="channel-subscribe-user-data-consent"
                            class="channel-user-data-consent checkbox-icon"
                            value="1"
                            required="required"
                        />
                        <label for="channel-subscribe-user-data-consent" class="checkbox-icon-label">
                            <div class="checkbox-icon checkbox-icon-unchecked"><span class="material-symbols-outlined">check_box_outline_blank</span></div>
                            <div class="checkbox-icon checkbox-icon-checked"><span class="material-symbols-outlined">check_box</span></div>
                            <p>${khMessage('channelSubscribeConsent', "I confirm that my user information will be shared with the channel provider when I subscribe, and that I accept the provider's privacy policy.")}</p>
                        </label>
                    </div>
                    <div id="channel-subscribe-error" class="channel-subscribe-error" style="display:none;"></div>
                </div>
                <div class="channel-subscribe-footer">
                    <button type="button" class="btn btn-secondary channel-subscribe-close">${khMessage('cancel', 'Cancel')}</button>
                    <button type="button" id="channel-subscribe-confirm" class="btn btn-primary">${khMessage('channelSubscribeButton', 'Subscribe to this channel')}</button>
                </div>
            </div>
        </div>
    `;

    jQuery('body').append(modalHtml);

    channelSubscribeModal = jQuery('#channel-subscribe-modal');
    channelSubscribeModalCheckbox = jQuery('#channel-subscribe-user-data-consent');
    channelSubscribeModalError = jQuery('#channel-subscribe-error');
    channelSubscribeModalConfirm = jQuery('#channel-subscribe-confirm');
}

function setChannelSubscribeError(message) {
    if (!channelSubscribeModalError) {
        return;
    }

    channelSubscribeModalError.text(message || '');
    channelSubscribeModalError.toggle(!!message);
}

function closeChannelSubscribeModal() {
    if (!channelSubscribeModal) {
        return;
    }

    channelSubscribeModal.hide();
    channelSubscribeModalCheckbox.prop('checked', false).removeClass('is-invalid');
    setChannelSubscribeError('');
    channelSubscribeModalConfirm.prop('disabled', false);
    pendingSubscribeButton = null;
    pendingSubscribeTeamId = null;
}

function openChannelSubscribeModal(button, teamId) {
    buildChannelSubscribeModal();
    pendingSubscribeButton = button;
    pendingSubscribeTeamId = teamId;
    channelSubscribeModal.css('display', 'flex');
    channelSubscribeModalCheckbox.prop('checked', false).removeClass('is-invalid').trigger('focus');
    setChannelSubscribeError('');
}

function submitChannelSubscription(button, teamId) {
    const notifier = getChannelSubscribeNotifier();

    if (button.prop('disabled')) {
        return;
    }

    button.prop('disabled', true);
    notifier.warning(khMessage('channelSubscribing', 'Subscribing to channel...'), {
        durations: {
            global: 5000
        }
    });

    khRestAjax({
        method: 'POST',
        path: 'team/' + encodeURIComponent(teamId) + '/join',
        data: {
            user_data_transfer_consent: true,
        },
        success: function (data) {
            if (!isApiSuccess(data)) {
                notifier.alert(getApiMessage(data, khMessage('channelCouldNotSubscribe', 'Channel could not be subscribed.')), {
                    durations: {
                        global: 5000
                    }
                });
                button.prop('disabled', false);
                return;
            }

            closeChannelSubscribeModal();

            notifier.success(getChannelSubscribeSuccessMessage(data), {
                durations: {
                    global: 5000
                }
            });

            khReloadWithRefreshData(5000);
        },
        error: function () {
            notifier.alert(khMessage('channelCouldNotSubscribe', 'Channel could not be subscribed.'), {
                durations: {
                    global: 5000
                }
            });
            button.prop('disabled', false);
        }
    });
}

jQuery(document).on("click", "button.subscribe-team", function () {
    const button = jQuery(this);
    const teamId = button.data('team-id');

    if (!teamId || button.prop('disabled')) {
        return;
    }

    openChannelSubscribeModal(button, teamId);
});

jQuery(document).on("click", ".channel-subscribe-close", function () {
    closeChannelSubscribeModal();
});

jQuery(document).on("click", "#channel-subscribe-modal", function (event) {
    if (event.target === this) {
        closeChannelSubscribeModal();
    }
});

jQuery(document).on("click", "#channel-subscribe-confirm", function () {
    if (!pendingSubscribeButton || !pendingSubscribeTeamId) {
        closeChannelSubscribeModal();
        return;
    }

    if (!channelSubscribeModalCheckbox.is(':checked')) {
        channelSubscribeModalCheckbox.addClass('is-invalid');
        setChannelSubscribeError(khMessage('channelSubscribeConsentError', 'Please confirm that your user information may be transferred to the channel.'));
        return;
    }

    channelSubscribeModalCheckbox.removeClass('is-invalid');
    setChannelSubscribeError('');
    channelSubscribeModalConfirm.prop('disabled', true);

    submitChannelSubscription(pendingSubscribeButton, pendingSubscribeTeamId);
});

jQuery(document).on("click", "#join-team-confirm", function () {
    if (window.khChannelJoinByCodeHandledInTemplate) {
        return;
    }

    // Close any visible error
    jQuery("#join-team-error").hide();

    // Read correct input field from modal
    let code = jQuery('#team-access-code').val().trim();

    if (!code || code.length === 0) {
        jQuery("#join-team-error")
            .text(khMessage('channelAccessCodeRequired', 'Please enter an access code.'))
            .show();
        return;
    }

    let consentCheckbox = jQuery('#channel-code-user-data-consent');
    if (consentCheckbox.length > 0 && !consentCheckbox.is(':checked')) {
        consentCheckbox.addClass('is-invalid');
        jQuery("#join-team-error")
            .text(khMessage('channelSubscribeConsentError', 'Please confirm that your user information may be transferred to the channel.'))
            .show();
        return;
    }
    consentCheckbox.removeClass('is-invalid');

    let globalOptions = {
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('success', 'Success'),
            warning: khMessage('attention', 'Attention')
        }
    };
    let notifier = new AWN(globalOptions);

    notifier.warning(khMessage('channelCheckingCode', 'Checking code...'), {

        durations: {
            global: 5000
        }
    });

    khRestAjax({
        method: 'POST',
        path: 'team/join-by-code',
        data: {
            code: code,
            user_data_transfer_consent: true,
        },
        success: function (data) {

            // Close modal
            jQuery("#join-team-modal").css("display", "none");

            let apiStatus = null;
            let payload = getApiPayload(data);

            if (payload && typeof payload.status !== "undefined") {
                apiStatus = String(payload.status).toLowerCase();
            }

            if (apiStatus === "false") {
                notifier.alert(payload?.message || khMessage('error', 'Error'), {

                    durations: {global: 5000}
                });
            } else if (apiStatus === "true" || isChannelWaitlistResponse(data)) {
                notifier.success(
                    isChannelWaitlistResponse(data) ? channelWaitlistMessage : (payload?.message || khMessage('channelJoinSuccess', 'Channel successfully joined.')),
                    {

                        durations: {global: 5000}
                    }
                );
            } else {
                notifier.alert(khMessage('unexpectedServerResponse', 'Unexpected server response.'), {

                    durations: {global: 5000}
                });
            }

            khReloadWithRefreshData(5000);
        },
        error: function () {
            jQuery("#join-team-error")
                .text(khMessage('channelAccessCodeInvalid', 'The access code is invalid or expired.'))
                .show();
        }
    });
});

jQuery(document).on("click", "button.unsubscribe-team", function () {
    let button = jQuery(this);
    let team_id = button.data('team-id');
    let row = button.closest('[data-network-row], .t-table-row');
    let globalOptions = {
        labels: {
            info: khMessage('info', 'Info'),
            success: khMessage('success', 'Success'),
            warning: khMessage('attention', 'Attention'),
            alert: khMessage('error', 'Error')
        }
    };
    let notifier = new AWN(globalOptions);
    notifier.info(khMessage('channelUnsubscribing', 'Unsubscribing from channel...'), {

        durations: {
            global: 5000
        }
    });
    button.prop('disabled', true);

    khRestAjax({
        method: 'POST',
        path: 'team/' + encodeURIComponent(team_id) + '/leave',
        success: function (data) {
            if (!isApiSuccess(data)) {
                notifier.alert(getApiMessage(data, khMessage('channelCouldNotUnsubscribe', 'Channel could not be unsubscribed.')), {
                    durations: {
                        global: 5000
                    }
                });
                button.prop('disabled', false);
                return;
            }

            if (getApiMessage(data, '')) {
                notifier.success(getApiMessage(data, ''), {

                    durations: {
                        global: 5000
                    }
                });
            } else {
                notifier.success(khMessage('channelUnsubscribeSuccess', 'Channel successfully unsubscribed.'), {

                    durations: {
                        global: 5000
                    }
                });


            }

            row.fadeOut(150, function () {
                jQuery(this).remove();
            });

            jQuery('#lef-nav-' + String(team_id).replace(/[^0-9]/g, '')).fadeOut(150, function () {
                jQuery(this).remove();
            });
            khRefreshSessionData();
        },
        error: function (errorThrown) {
            notifier.alert(khMessage('channelCouldNotUnsubscribe', 'Channel could not be unsubscribed.'), {
                durations: {
                    global: 5000
                }
            });
            button.prop('disabled', false);
        }
    });
});
jQuery(function ($) {

    const forbidden = /["'\\`]|^\s|\s$/;

    const errorTitle = passwordValidation.errorTitle;
    const errorMessage = passwordValidation.errorMessage;

    function attachPasswordValidation(formSelector, pwOldSelector, pw1Selector, pw2Selector, submitSelector) {

        const form = $(formSelector);
        const pwOld = pwOldSelector ? $(pwOldSelector) : null;
        const pw1 = $(pw1Selector);
        const pw2 = $(pw2Selector);
        const submitBtn = $(submitSelector);

        if (!form.length) return;
        if (!pw1.length || !pw2.length || !submitBtn.length) return;

        function showError(targetField) {
            $('#password-invalid-error').remove();

            const html =
                '<div id="password-invalid-error" class="notice notice-error">' +
                '<p><strong>' + errorTitle + ':</strong> ' + errorMessage + '</p>' +
                '</div>';

            // Registrierungsformular?
            let container = targetField.closest('.register-user-data');

            // Passwort ändern?
            if (!container.length) {
                container = targetField.closest('.t-table-cell');
            }

            // Falls gar nichts gefunden → Nachricht direkt hinter das Feld setzen
            if (!container.length) {
                container = targetField.parent();
            }

            container.append(html);

            submitBtn.prop('disabled', true).addClass('disabled-submit-btn');
        }

        function validateLive(field) {
            const val = field.val();
            $('#password-invalid-error').remove();

            if (forbidden.test(val)) {
                showError(field);
            } else {
                submitBtn.prop('disabled', false).removeClass('disabled-submit-btn');
            }
        }

        // On submit
        form.on('submit', function (e) {
            $('#password-invalid-error').remove();

            const val1 = pw1.val();
            const val2 = pw2.val();

            if (forbidden.test(val1) || forbidden.test(val2)) {
                e.preventDefault();
                showError(pw2);
                return false;
            }

            submitBtn.prop('disabled', false).removeClass('disabled-submit-btn');
            return true;
        });

        // Live validation
        pw1.on('input', () => validateLive(pw1));
        pw2.on('input', () => validateLive(pw2));
    }

    // Registration page
    attachPasswordValidation(
        '#t-registerform',
        null,
        '#user_password_one',
        '#user_password_two',
        '#teejit-register-submit'
    );

    // Change password page
    attachPasswordValidation(
        'form.edit-profil-data',
        '#password-0',
        '#password-1',
        '#password-2',
        '.btn.btn-primary'
    );

    // Forgot password page with manual password reset
    attachPasswordValidation(
        '#t-lostpassword-form',
        null,
        '#user_password_one',
        '#user_password_two',
        '#teejit-login-submit'
    );

});
